// Header search with live suggestions (sections/header_new.liquid: #navbar-search-form).
//
// As the visitor types, Shopify's predictive search (/search/suggest.json) is asked for
// matching products, collections and search phrases, and the results are shown under
// the box. Keyboard: arrow keys move through the results, Enter opens the highlighted one
// (or searches for the typed text), Escape closes the list.
(function () {
  'use strict';

  var form = document.getElementById('navbar-search-form');
  var input = document.getElementById('navbar-search-input');
  var panel = document.getElementById('navbar-search-dropdown');
  if (!form || !input || !panel) return;

  var MIN_CHARS = 2;
  var DELAY = 180;          // ms to wait after the last key press
  var PRODUCT_LIMIT = 6;

  var cache = {};
  var timer = null;
  var controller = null;
  var activeIndex = -1;
  var lastQuery = '';

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-expanded', 'false');
  input.setAttribute('aria-controls', 'navbar-search-dropdown');
  panel.setAttribute('role', 'listbox');

  // ---------- helpers ----------
  function escapeHtml(text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
    });
  }

  // Wrap the typed words in <mark>, on already-escaped text.
  function highlight(text, query) {
    var safe = escapeHtml(text);
    var words = query.trim().split(/\s+/).filter(Boolean).map(function (w) {
      return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    if (!words.length) return safe;
    return safe.replace(new RegExp('(' + words.map(escapeHtml).join('|') + ')', 'ig'), '<mark>$1</mark>');
  }

  function money(amount) {
    var value = Number(amount);
    if (!isFinite(value)) return '';
    var formatted = value.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    var format = (window.theme && theme.settings && theme.settings.moneyFormat) || 'Dhs. {{amount}}';
    // the store format may contain HTML (e.g. a <span class="money">) - keep only its text
    var plain = format.replace(/<[^>]*>/g, '');
    return plain.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, formatted);
  }

  function cleanUrl(url) {
    // Shopify adds tracking parameters to suggestion links; they are harmless, keep them.
    return url || '#';
  }

  function searchUrl(query) {
    return '/search?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last&type=product';
  }

  // ---------- open / close ----------
  function open() {
    panel.classList.add('active');
    input.setAttribute('aria-expanded', 'true');
  }

  function close() {
    panel.classList.remove('active');
    input.setAttribute('aria-expanded', 'false');
    activeIndex = -1;
  }

  // ---------- rendering ----------
  function render(query, data) {
    var results = (data && data.resources && data.resources.results) || {};
    var products = results.products || [];
    var collections = results.collections || [];
    var queries = (results.queries || []).filter(function (q) {
      return q.text && q.text.toLowerCase() !== query.toLowerCase();
    });

    if (!products.length && !collections.length && !queries.length) {
      panel.innerHTML =
        '<div class="lb-search__empty">No results for <strong>"' + escapeHtml(query) + '"</strong>.' +
        '<span>Try a brand (VUAE, Trek, Spartan) or a type (helmet, kids bike).</span></div>';
      open();
      return;
    }

    var html = '';

    if (queries.length || collections.length) {
      html += '<div class="lb-search__chips">';
      queries.slice(0, 4).forEach(function (q) {
        html += '<a class="lb-search__chip lb-search__option" role="option" href="' + escapeHtml(searchUrl(q.text)) + '">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>' +
          highlight(q.text, query) + '</a>';
      });
      collections.slice(0, 3).forEach(function (c) {
        html += '<a class="lb-search__chip lb-search__chip--collection lb-search__option" role="option" href="' + escapeHtml(cleanUrl(c.url)) + '">' +
          '<span>Collection</span>' + highlight(c.title, query) + '</a>';
      });
      html += '</div>';
    }

    if (products.length) {
      html += '<div class="lb-search__heading">Products</div><div class="lb-search__products">';
      products.slice(0, PRODUCT_LIMIT).forEach(function (p) {
        var image = (p.featured_image && p.featured_image.url) || p.image || '';
        var onSale = Number(p.compare_at_price_max) > Number(p.price);
        html += '<a class="lb-search__product lb-search__option" role="option" href="' + escapeHtml(cleanUrl(p.url)) + '">' +
          '<span class="lb-search__thumb">' +
            (image ? '<img src="' + escapeHtml(image) + (image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '') +
          '</span>' +
          '<span class="lb-search__info">' +
            (p.vendor ? '<span class="lb-search__vendor">' + escapeHtml(p.vendor) + '</span>' : '') +
            '<span class="lb-search__title">' + highlight(p.title, query) + '</span>' +
            '<span class="lb-search__price">' +
              (onSale ? '<s>' + escapeHtml(money(p.compare_at_price_max)) + '</s>' : '') +
              escapeHtml(money(p.price)) +
              (p.available === false ? '<em>Sold out</em>' : '') +
            '</span>' +
          '</span>' +
        '</a>';
      });
      html += '</div>';
    }

    html += '<a class="lb-search__all lb-search__option" role="option" href="' + escapeHtml(searchUrl(query)) + '">' +
      'See all results for "' + escapeHtml(query) + '"' +
      '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';

    panel.innerHTML = html;
    activeIndex = -1;
    open();
  }

  function renderLoading() {
    if (panel.classList.contains('active') && panel.querySelector('.lb-search__option')) {
      panel.classList.add('is-loading'); // keep old results visible, just dim them
      return;
    }
    panel.innerHTML = '<div class="lb-search__loading"><span></span><span></span><span></span></div>';
    open();
  }

  // ---------- fetching ----------
  function search(query) {
    lastQuery = query;
    if (cache[query]) {
      panel.classList.remove('is-loading');
      render(query, cache[query]);
      return;
    }
    if (controller) controller.abort();
    controller = window.AbortController ? new AbortController() : null;
    renderLoading();

    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,query' +
      '&resources[limit]=' + PRODUCT_LIMIT +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

    fetch(url, {headers: {Accept: 'application/json'}, signal: controller ? controller.signal : undefined})
      .then(function (r) {
        if (!r.ok) throw new Error('Search failed');
        return r.json();
      })
      .then(function (data) {
        cache[query] = data;
        if (query !== lastQuery) return; // the visitor has typed something newer
        panel.classList.remove('is-loading');
        render(query, data);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        panel.classList.remove('is-loading');
        close();
      });
  }

  // ---------- events ----------
  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(timer);
    if (query.length < MIN_CHARS) {
      lastQuery = '';
      if (controller) controller.abort();
      close();
      return;
    }
    timer = setTimeout(function () { search(query); }, DELAY);
  });

  input.addEventListener('focus', function () {
    var query = input.value.trim();
    if (query.length >= MIN_CHARS) search(query);
  });

  input.addEventListener('keydown', function (event) {
    var options = panel.querySelectorAll('.lb-search__option');
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (!panel.classList.contains('active') || !options.length) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      activeIndex += event.key === 'ArrowDown' ? 1 : -1;
      if (activeIndex >= options.length) activeIndex = 0;
      if (activeIndex < 0) activeIndex = options.length - 1;
      options.forEach(function (o, i) {
        o.classList.toggle('is-active', i === activeIndex);
        o.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
      });
      options[activeIndex].scrollIntoView({block: 'nearest'});
    } else if (event.key === 'Enter' && activeIndex > -1) {
      event.preventDefault();
      window.location.href = options[activeIndex].getAttribute('href');
    }
  });

  form.addEventListener('submit', function (event) {
    var query = input.value.trim();
    event.preventDefault();
    if (!query) {
      input.focus();
      return;
    }
    window.location.href = searchUrl(query);
  });

  document.addEventListener('click', function (event) {
    if (!form.contains(event.target) && !panel.contains(event.target)) close();
  });

  // Clear (x) button inside the box
  var clearBtn = form.querySelector('.lb-searchbox__clear');
  function syncClear() {
    if (clearBtn) clearBtn.hidden = input.value === '';
  }
  input.addEventListener('input', syncClear);
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      syncClear();
      close();
      input.focus();
    });
  }
  syncClear();
})();
